import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {MaterialNode} from "#template/nodes/material/material-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {NumberLike, StringLike} from "#template/nodes/types"
import {numberLike} from "#template/nodes/number/fundamental"
import {stringLike} from "#template/nodes/string/fundamental"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {MaterialGraph} from "@cm/material-nodes"
import {FindMaterial as FindMaterialNode} from "#template/runtime-graph/nodes/find-material"

export type FindMaterialParameters = {
    customerId?: NumberLike
    articleId?: StringLike
}

const findMaterialDefinition: TemplateNodeDefinition<FindMaterialParameters> = {
    nodeClass: "FindMaterial",
    validation: {
        parameters: z.object({
            customerId: z.optional(numberLike),
            articleId: z.optional(stringLike),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class FindMaterial extends MaterialNode<FindMaterialParameters> {
    public override get definition() {
        return findMaterialDefinition
    }

    public override evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<MaterialGraph | null> {
        const {templateContext} = evaluator
        const {sceneManager, defaultCustomerId} = templateContext
        const {materialGraph} = scope.node(FindMaterialNode, {
            sceneManager,
            articleId: evaluator.evaluate(this.parameters.articleId ?? null),
            customerId: evaluator.evaluate(this.parameters.customerId ?? defaultCustomerId ?? null),
            flatten: true,
        })
        return materialGraph
    }
}
